/* eslint-disable import/extensions */
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";

// * if service fail show mock data
// TODO: Change all for productive links
import { menusHeader } from "../mocks/headerContent";

import { myPurchasesIcon, benefitsIcon, assistanceIcon } from "./svgIcons.js";
import CommonUtil from "../../../utils/commonUtil.js";
import { constBrand } from '../../../utils/clientConstant.js';
import HeaderBrand from "./HeaderBrand";
import NewHeaderBrand from "./HeaderNewBrand.jsx";
import HeaderBrandWap from "./HeaderWap/HeaderBrandWap";
import ApplyCSS from "../../../components/ApplyCSS";
import * as BrowseAndNevigateSearchAction from "../../../pages/BrowseAndNavigate/BrowseAndNevigateSearch/actions";
import HeaderTopContainer from "./HeaderTopContainer.jsx";
import NewHeaderCategoriesMultisites from './NewHeaderCategoriesMultisites.jsx';
const channel = CommonUtil.getChannel();

const textNodeServices = "servicios";
const textNodeOtherSites = "otros sitios";
const iconsForSubmenuUser = [
  myPurchasesIcon("#333333"),
  benefitsIcon("#333333"),
  assistanceIcon("#333333"),
];

@connect(
  (store) => ({
    user: store.user.data,
    megaMenuData: store.megaMenuData.data,
    linksMenuData: store.linksMenuData.data ? store.linksMenuData.data : {},
    home: store.labels.data.home,
    newLinksMenuData: store.globalData.data || {},
    globalObject: store.globleObject,
    newMegaMenuData: store.newMegaMenuData.data,
  }),
  { ...BrowseAndNevigateSearchAction }
)
class HeaderContainer extends Component {
  constructor(props) {
    super(props);
    const { linksMenuData, newLinksMenuData } = this.props;
    const {
      // topRightLinks,
      // userDataDropdownGuest,
      // userDataDropdownLogged,
      menuWapPathsConfigLogged,
    } = linksMenuData || {};
    const { topRightLinks, userDataDropdownGuest, userDataDropdownLogged } =
      newLinksMenuData || {};

    const dropdownGuess = menusHeader.userDataDropdownGuest.links;
    const dropdownLogged = menusHeader.userDataDropdownLogged.links;
    const pathWapLogged = menusHeader.menuWapPathsConfigLogged.links;
    const headerTopRightLinks = menusHeader.topRightLinks;
    const menuCategories = menusHeader.megaMenu[0];
    const categoriesResponse =
      this.props.newMegaMenuData && this.props.newMegaMenuData.l1Categories
        ? this.props.newMegaMenuData
        : null;

    this.megaMenuData = categoriesResponse || menuCategories;
    this.topRightLinks =
      topRightLinks && topRightLinks.links
        ? topRightLinks
        : headerTopRightLinks;
    this.userDataDropdownGuest =
      (userDataDropdownGuest && userDataDropdownGuest.links) || dropdownGuess;
    this.userDataDropdownLogged =
      (userDataDropdownLogged && userDataDropdownLogged.links) ||
      dropdownLogged;
    const accountLinks = newLinksMenuData?.loggedUserDataDropdown?.links?.[0]?.['account_links'] || []
    const encuentaItem = newLinksMenuData?.topRightLinks?.links?.[0];
    this.menuWapPathsConfigLogged = [accountLinks[0], ...(encuentaItem ? [encuentaItem] : []),...accountLinks.slice(1)] ||  [];
    this.state = {
      otherSites: [],
      servicesData: [],
      services: [],
    };
  }

  componentDidMount() {
    this.getData();
  }

  setDataSubmenuUserLogged = (userLoggedMenu, hasActiveSession) =>
    userLoggedMenu.map((item, index) => {
      if (index === 1 && hasActiveSession) {
        return {
          url: item.url,
          text: item.name || item.label,
          icon: iconsForSubmenuUser[index],
        };
      }

      return {
        url: item.url,
        text: item.name || item.label,
        icon: iconsForSubmenuUser[index],
      };
    });

  getData = () => {
    const topRightLinks =
      (this.props.newLinksMenuData &&
        this.props.newLinksMenuData.topRightLinks &&
        this.props.newLinksMenuData.topRightLinks.links) ||
      [];
    const { userDataDropdownGuest, userDataDropdownLogged } =
      this.props.newLinksMenuData || {};
    const userDataDropdownGuestData =
      (userDataDropdownGuest && userDataDropdownGuest.links) ||
      this.userDataDropdownGuest;
    const userDataDropdownLoggedData =
      (userDataDropdownLogged && userDataDropdownLogged.links) ||
      this.userDataDropdownLogged;
    const { links } = this.topRightLinks;
    const findNodeExtraData = (textNode) =>
      links.find((itemData) => itemData.text?.toLowerCase() === textNode);
    const findNewNodeExtraData = (textNode) =>
      links.find(
        (itemData) =>
          itemData.label?.toLowerCase() === textNode ||
          itemData.text?.toLowerCase() === textNode,
      );
    const servicesData = findNewNodeExtraData(textNodeServices)?.items;
    const otherSitesData = findNewNodeExtraData(textNodeOtherSites)?.items;
    const categoriesResponse = this.props?.newMegaMenuData?.l1Categories
      ? this.props?.newMegaMenuData
      : null;
    const headerTopRightLinks = menusHeader.topRightLinks;
    this.setState({
      ...this.state,
      servicesData,
      otherSites: otherSitesData,
      categories: categoriesResponse || this.megaMenuData,
      topRightLinks:
        topRightLinks.length > 0 ? topRightLinks : headerTopRightLinks,
      userDataDropdownGuest: userDataDropdownGuestData,
      userDataDropdownLogged: userDataDropdownLoggedData,
    });
  };

  render() {
    const { servicesData, otherSites: otherSitesData, categories } = this.state;
    const {
      home,
      handleLoginWithAuth0,
      handleLogoutWithAuth0,
      routerPaths,
      returnClickHandler,
      user = {},
    } = this.props;

    const brandNameSite = CommonUtil.getBrand();
    const { l1Categories = [] } = categories || {};
    const categoriesMultisites = [...l1Categories].splice(0, 8);
    const hasCategoriesMultisites = ['WS', 'WLM', 'PB', 'PBK', 'GAP'];
    const result = user?.result || {};
    const { profileId = false } = result;

    return (
      <Fragment>
        <ApplyCSS pageName="headerLP" />
        {channel !== "wap" ? (
          <Fragment>
            <HeaderTopContainer
              services={servicesData}
              otherSites={otherSitesData}
              linksHeaderTop={this.topRightLinks}
              home={home}
            />
            <NewHeaderBrand
              megamenu={categories}
              userDataDropdownGuest={this.setDataSubmenuUserLogged(
                this.userDataDropdownGuest,
              )}
              userDataDropdownLogged={this.setDataSubmenuUserLogged(
                this.userDataDropdownLogged,
                profileId,
              )}
              handleLoginWithAuth0={handleLoginWithAuth0}
              handleLogoutWithAuth0={handleLogoutWithAuth0}
            />
            {hasCategoriesMultisites.some(
              (key) => key === constBrand[brandNameSite],
            ) && (
              <NewHeaderCategoriesMultisites
                categoryList={categoriesMultisites}
              />
            )}
          </Fragment>
        ) : (
          <Fragment>
            <HeaderTopContainer />
            {
              <HeaderBrandWap
                services={servicesData}
                routerPaths={routerPaths}
                returnClickHandler={returnClickHandler}
                otherSites={otherSitesData}
                linksHeaderTop={this.topRightLinks}
                megamenu={categories}
                handleLoginWithAuth0={handleLoginWithAuth0}
                handleLogoutWithAuth0={handleLogoutWithAuth0}
                menuWapPathsConfigLogged={this.menuWapPathsConfigLogged}
                hideSearch={this.props.hideSearch}
              />
            }
          </Fragment>
        )}
      </Fragment>
    );
  }
}

export default HeaderContainer;
